import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AssetQrApprovalLinkComponent } from './asset-qr-approval-link/asset-qr-approval-link.component';
import { AssetQrApprovalLandingComponent } from './asset-qr-approval-landing/asset-qr-approval-landing.component';

const routes: Routes = [
  {path:'',component:AssetQrApprovalLinkComponent,
    children:[
      {
        path:'assetQRApproval',component:AssetQrApprovalLandingComponent
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AssetqrapprovalRoutingModule { }
